import { render, staticRenderFns } from "./TierForm.vue?vue&type=template&id=4fd76818"
import script from "./TierForm.vue?vue&type=script&lang=js"
export * from "./TierForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports